import React, { useState, useContext, useEffect } from 'react';
import 'antd/dist/antd.css';
import { Drawer } from 'antd';

import UserDetailsHeader from './UserDetailsHeader';
import UserDetailsSubInfo from './UserDetailsSubInfo';
import UserDetailsAccount from './UserDetailsAccount';
import UserDetailsBilling from './UserDetailsBilling';
import UserDetailsSubscription from './UserDetailsSubscription';
import InfoAboutFullFunctionalityPro from './InfoAboutFullFunctionalityPro';
import SelectedViewUserDetails from './SelectedViewUserDetails';
import { AppContext } from 'context/AppContext';

import EditUserAccountDetails from './EditUserAccountDetails';
import SupportUs from 'components/SupportUs';

const MainUserDetailsDrawer = (props) => {
    let appContext = useContext(AppContext);

    const [rerenderUserDetailsDrawer, setRerenderUserDetailsDrawer] =
        useState(false);
    const [visibleEditAccount, setVisibleEditAccount] = useState(false);

    const showDrawerEditAccount = () => {
        setVisibleEditAccount(true);
    };

    const onCloseEditAccount = () => {
        setVisibleEditAccount(false);
    };

    const activeDetailTab = appContext.defaults.sub_is_active
        ? 'account'
        : 'subscription';

    const [selectToShowInformation, setSelectToShowInformation] =
        useState(activeDetailTab);

    return (
        <>
            <Drawer
                // title="Basic Drawer"
                placement="right"
                onClose={props.onCloseUserDrawer}
                // visible={props.visibleUserDrawer}
                visible={appContext.mainUserDetailsDrawerIsVisible}
                closable={false}
                width={357}
            >
            <div className='main-right-drawer-container'>
            <div>
                <div className="payments-drawer">
                    <UserDetailsHeader
                        showDrawerEditAccount={showDrawerEditAccount}
                        onCloseEditAccount={onCloseEditAccount}
                        visibleEditAccount={visibleEditAccount}
                        setVisibleEditAccount={setVisibleEditAccount}
                    />
                    <hr className="hr" />
                    <UserDetailsSubInfo
                        setSelectToShowInformation={setSelectToShowInformation}
                        selectToShowInformation={selectToShowInformation}
                    />
                    <hr className="hr" />
                    <SelectedViewUserDetails
                        selectToShowInformation={selectToShowInformation}
                        setSelectToShowInformation={setSelectToShowInformation}
                    />

                    {selectToShowInformation === 'account' ? (
                        <UserDetailsAccount
                            rerenderUserDetailsDrawer={
                                rerenderUserDetailsDrawer
                            }
                            setRerenderUserDetailsDrawer={
                                setRerenderUserDetailsDrawer
                            }
                            showDrawerEditAccount={showDrawerEditAccount}
                            onCloseEditAccount={onCloseEditAccount}
                            visibleEditAccount={visibleEditAccount}
                            setVisibleEditAccount={setVisibleEditAccount}
                        />
                    ) : null}

                    {selectToShowInformation === 'billing' ? (
                        <UserDetailsBilling />
                    ) : null}

                    {selectToShowInformation === 'subscription' ? (
                        <UserDetailsSubscription />
                    ) : null}
                </div>
                {visibleEditAccount && (
                    <EditUserAccountDetails
                        visible={visibleEditAccount}
                        setVisible={setVisibleEditAccount}
                        showDrawer={showDrawerEditAccount}
                        onClose={onCloseEditAccount}
                        rerenderUserDetailsDrawer={rerenderUserDetailsDrawer}
                        setRerenderUserDetailsDrawer={
                            setRerenderUserDetailsDrawer
                        }
                        firstName={appContext.defaults.first_name}
                        lastName={appContext.defaults.last_name}
                    />
                )}
            </div>
            <div className='supportus-dark'>
                <SupportUs/>
            </div>
            </div>
            </Drawer>
        </>
    );
};

export default MainUserDetailsDrawer;
